import {
  VALIDATING_MS_DYNAMICS_INSTANCE_SUCCEDDED,
  AUTHENTICATING_MS_DYNAMICS_REQUEST, AUTHENTICATING_MS_DYNAMICS_SUCCEDDED, AUTHENTICATING_MS_DYNAMICS_FAILED,
  UPDATING_MS_DYNAMICS_REQUEST, UPDATING_MS_DYNAMICS_SUCCEDDED, UPDATING_MS_DYNAMICS_FAILED,
  FETCHING_MS_DYNAMICS_INTEGRATION_REQUEST, FETCHING_MS_DYNAMICS_INTEGRATION_SUCCEDDED, FETCHING_MS_DYNAMICS_INTEGRATION_FAILED,
  } from '../../actions/actionTypes.jsx';
  
  const initialState = {
    changes: {
      saving: false,
      error: null
    },
    authentication: {
      authenticating: false,
      error: null
    }
  };
  
  function msDynamicsReducer(state = initialState, action) {
  switch (action.type) {
    case VALIDATING_MS_DYNAMICS_INSTANCE_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        validInstance: action.payload.success
    }) 
    case AUTHENTICATING_MS_DYNAMICS_REQUEST:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: true,
          error: null
        }
      })
    case AUTHENTICATING_MS_DYNAMICS_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: false,
          error: null
        }
      })
    case AUTHENTICATING_MS_DYNAMICS_FAILED:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: false,
          error: action.payload
        }
      }) 
    case UPDATING_MS_DYNAMICS_REQUEST:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: true,
          error: null
        }
      })
    case UPDATING_MS_DYNAMICS_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: null
        }
      })
    case UPDATING_MS_DYNAMICS_FAILED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: action.payload
        }
      })
    case FETCHING_MS_DYNAMICS_INTEGRATION_REQUEST:
      return Object.assign({}, state, {
        ...state,
        changes: {
          ...state.changes,
          loading: true
        }
      }) 
    case FETCHING_MS_DYNAMICS_INTEGRATION_SUCCEDDED: 
      return Object.assign({}, state, {
        ...state,
        changes: {
          ...state.changes,
          loading: false
        }
      }) 
    case FETCHING_MS_DYNAMICS_INTEGRATION_FAILED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          ...state.changes,
          loading: false
        }
      })    
    default:
      return state;
  }
  }
  
  export { msDynamicsReducer };